module.exports = __webpack_public_path__ + "img/91ne.50f73536.svg";